export const screenshotEventName = "screenshot";

export interface ScreenshotEventDetail {
    timestamp: Date;
}

export type ScreenshotEvent = CustomEvent<ScreenshotEventDetail>;

export const createScreenshotEvent = (now = new Date()) => {
    return new CustomEvent<ScreenshotEventDetail>(screenshotEventName, {
        detail: { timestamp: now },
        bubbles: true,
    });
};
